<script setup>
import { ref, watch, computed } from 'vue';
import { useNotificationStore } from '@/stores/notification';
const notificationStore = useNotificationStore();

const props = defineProps({
  notification: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['hideNotification']);

const isFadingOut = ref(false);

const hideNotification = (id) => {
  isFadingOut.value = true;
  setTimeout(() => {
    emit('hideNotification', id);
    isFadingOut.value = false;
  }, 400); // Dauer der Fade-Out-Animation (muss zu CSS passen)
};

// Automatisch ausblenden, wenn notification.class === 'success'
watch(
  () => props.notification,
  (notif) => {
    if (notif.class === 'success' && notif.visible) {
      setTimeout(() => {
        hideNotification(notif.id);
      }, 2000); // 2 Sekunden sichtbar
    }
  },
  { immediate: true, deep: true }
);

const canExpand = computed(() => props.notification.class !== 'success' && props.notification.count >= 1);
</script>

<template>
  <div
    v-if="notification.visible"
    :class="['notification', notification.class, { 'fade-out': isFadingOut }]"
    @click="canExpand && (notification.showTimes = !notification.showTimes)"
  >
    <div class="txtWrapper">
      <!-- Ein einzelnes weißes Glyph auf der farbigen Karte statt einem
           eigenen, separat eingefärbten Icon-Kreis (der zuvor bei error/warning
           fälschlich grün war, da alle drei Varianten denselben hartkodierten
           fill="#5bb543" nutzten) — Farbe kommt jetzt allein von der Karte. -->
      <svg v-if="notification.class === 'success'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
      <svg v-else-if="notification.class === 'error'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
      <svg v-else-if="notification.class === 'warning'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 9v4"/>
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z"/>
        <circle cx="12" cy="17" r="0.1" fill="#fff"/>
      </svg>
      <p>{{ notification.message }}<span v-if="notification.count >= 1"> ({{ notification.count }}x)</span></p>
      <svg v-if="canExpand" class="toggle-chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="6 9 12 15 18 9"/>
      </svg>
      <div class="btn-wrapper">
        <button v-if="notification.class !== 'success'" @click.stop="notificationStore.copyNotification(notification.id, $event)" class="copy-btn">
          Kopieren
        </button>
        <button v-if="notification.class !== 'success'" @click.stop="hideNotification(notification.id)" class="close-btn">
          <img src="@/assets/imgs/icons/xmark-solid.svg" />
        </button>
      </div>
    </div>
    <ul v-if="notification.showTimes && notification.count >= 1" class="notification-times">
      <li v-for="(t, i) in notification.times" :key="i"><p><span>{{ (i + 1) + '. Fehlermeldung: ' }}</span> {{ t }} Uhr</p></li>
    </ul>
  </div>
</template>